import { create } from 'zustand';

type State = {
  secondScreen: boolean;
  isLoaded: boolean;
  subMenu: {
    id: string;
    text: string;
  }[];
};

type Action = {
  setMenu: (
    arg: {
      id: string;
      text: string;
    }[],
  ) => void;
  setLoaded: () => void;
  setScreen: (arg: boolean) => void;
};

const PageStore = create<State & Action>((set) => ({
  secondScreen: false,
  subMenu: [],
  isLoaded: false,
  setLoaded: () => {
    set({
      isLoaded: true,
    });
  },
  setMenu: (subMenu) => {
    if (subMenu.length === 0) {
      const menus = Array.from(document.querySelectorAll('.layout-left h3.att-title'));
      const menuArr: {
        id: string;
        text: string;
      }[] = [];
      menus.forEach((heading, index) => {
        menuArr.push({
          id: heading.id,
          text: heading.textContent as string,
        });
      });
      set({
        subMenu: menuArr,
      });
    }
  },
  setScreen: (payload: boolean) => {
    set({
      secondScreen: payload,
    });
  },
}));

export default PageStore;
